import React from "react";
import { useDispatch } from "react-redux";

import { MuiThemeProvider } from "@material-ui/core/styles";
import { IconButton, Tooltip } from "@material-ui/core";

import Show from "@material-ui/icons/Visibility";
import Hide from "@material-ui/icons/VisibilityOff";
import Delete from "@material-ui/icons/Delete";
import Threshold from "@material-ui/icons/InvertColors";
import Unthreshold from "@material-ui/icons/InvertColorsOff";

import { smallIconButton } from "../../../theme";
import OpacityControl from "./OpacityControl";

import { Actions as imagery } from "../../../store/ducks/imagery";
import { BathymetryResults } from "../../pages/ProcessingBathymetryPage";
const LayerActions = ({ layer, index, parent }) => {
  const dispatch = useDispatch();

  const { visible, opacity, histogram, threshold, removable } = layer;
  const canThreshold = histogram && Object.keys(histogram).length === 1;
  const isThresholded = threshold !== undefined;

  const handleThreshold = () => {
    /*if (isThresholded) {
      basic.clearThreshold(index)
    } else {
      basic.solicitThreshold(index)
    }*/
  };
  setTimeout(() => {
    if (
      BathymetryResults.isBathymetry() &&
      BathymetryResults.hideBathymetryPivotLayer
    ) {
      BathymetryResults.hideBathymetryPivotLayer = false;
      dispatch(imagery.toggleVisibility(index));
      console.log("Hidding first layer bathymetry");
    }
  }, 4000);

  return (
    // @TODO i18n & theme
    <MuiThemeProvider theme={smallIconButton}>
      <div>
        {canThreshold && (
          <Tooltip
            title={isThresholded ? "Remove threshold" : "Threshold"}
            placement="top"
          >
            <IconButton onClick={() => handleThreshold()}>
              {isThresholded ? <Unthreshold /> : <Threshold />}
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title={visible ? "Hide" : "Show"} placement="top">
          <IconButton onClick={() => dispatch(imagery.toggleVisibility(index))}>
            {visible ? <Show /> : <Hide />}
          </IconButton>
        </Tooltip>

        <OpacityControl
          opacity={opacity}
          onOpacityChange={(v) => dispatch(imagery.updateOpacity(index, v))}
        />

        {removable && (
          <Tooltip title="Remove" placement="top">
            <IconButton
              onClick={() => {
                dispatch(imagery.removeLayer(index));
              }}
            >
              <Delete />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </MuiThemeProvider>
  );
};

export default LayerActions;
